import * as R from 'ramda';
import { createSelector } from 'reselect';
// feature fleet-map
import {
  getFilteredByTypeLocations,
  getFilteredByUnitIdTrailers,
  getFilteredByLoadedTrailers,
  getFilteredByIdleTimeTrailers,
  getFilteredByEnterpriseFleetsEntity,
} from './helpers';
//////////////////////////////////////////////////

const selectFleetMapStore = (state) => state.fleetMap;

const makeSelectFleets = () => createSelector(
  selectFleetMapStore,
  ({ fleets }) => fleets,
);

const makeSelectFilteredFleets = () => createSelector(
  selectFleetMapStore,
  ({
    fleets,
    idleTimeFilter,
    enterpriseFilter,
    trailerLoadedFilter,
    trailerUnitIdFilter,
  }) => {
    const getFilteredEntities = getFilteredByEnterpriseFleetsEntity(R.pluck('value', enterpriseFilter), fleets);

    return {
      ...fleets,
      trucks: getFilteredEntities('trucks'),
      drivers: getFilteredEntities('drivers'),
      trailers: R.compose(
        getFilteredByIdleTimeTrailers(idleTimeFilter),
        getFilteredByUnitIdTrailers(trailerUnitIdFilter),
        getFilteredByLoadedTrailers(trailerLoadedFilter),
      )(getFilteredEntities('trailers')),
    };
  },
);

const makeSelectGeoFencingLocation = () => createSelector(
  selectFleetMapStore,
  ({ geoFencingLocation, geoFencingTypeFilter }) =>
    getFilteredByTypeLocations(geoFencingTypeFilter, geoFencingLocation),
);

const makeSelectConfigs = () => createSelector(
  selectFleetMapStore,
  ({ configs }) => configs,
);

const makeSelectTrailerLoadedFilter = () => createSelector(
  selectFleetMapStore,
  ({ trailerLoadedFilter }) => trailerLoadedFilter,
);

const makeSelectTrailerUnitIdFilter = () => createSelector(
  selectFleetMapStore,
  ({ trailerUnitIdFilter }) => trailerUnitIdFilter,
);

const makeSelectFlyToLocation = () => createSelector(
  selectFleetMapStore,
  ({ flyToLocation }) => flyToLocation,
);

const makeSelectFlyToLocationValue = () => createSelector(
  selectFleetMapStore,
  ({ flyToLocationValue }) => flyToLocationValue,
);

export {
  makeSelectFleets,
  makeSelectConfigs,
  makeSelectFlyToLocation,
  makeSelectFilteredFleets,
  makeSelectFlyToLocationValue,
  makeSelectGeoFencingLocation,
  makeSelectTrailerLoadedFilter,
  makeSelectTrailerUnitIdFilter,
};
